// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"702c73b3","681":"a7784a47","815":"ab04a551"}[chunkId] + ".chunk.js";
};